<style lang="scss" scoped>
  .fs-16 {
    font-size: 1.15em !important;
  }
</style>
<template>

  <v-layout column wrap v-if="devices[selectedDevice].connected">

    <v-card color="transparent" class="transparent" elevation="0" max-width="600">
      <v-card-title class="pt-1">
        <v-layout row no-wrap justify-space-between>
          <v-flex shrink>
            <v-layout row wrap>
              <v-icon color="red" size="64">
                mdi-heart-pulse
              </v-icon>
              <v-flex d-flex align-center>
                <h3 class="grey--text text--darken-1 text-uppercase subheading">אק"ג</h3>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex shrink>
            <v-switch v-model="devices[selectedDevice].ecgstatus" :label="devices[selectedDevice].ecgstatus ? 'דולק' : 'כבוי'"></v-switch>
          </v-flex>
        </v-layout>
      </v-card-title>

      <v-sheet color="transparent" v-if="devices[selectedDevice].ecgstatus">
        <v-sparkline :key="ecgKey"
        :smooth="0"
        color="red"
        :line-width="2"
        :value="ecg"></v-sparkline>
      </v-sheet>
    </v-card>

    <v-layout row wrap justify-space-around>

      <v-flex xs12 class="mt-4">
        <v-layout row no-wrap justify-center>
          <v-flex d-flex align-end grow class="text-xs-left pl-2">
            <h3>אוקסימטר</h3>
          </v-flex>
          <v-flex d-flex align-end grow class="text-xs-right pr-2">
            <span v-if="po == 0" class="grey--text">לא מזהה אצבע</span>
            <span v-else-if="po == 1" class="blue--text body-2 fs-16">מזהה אצבע</span>
            <span v-else-if="po == 3 && (heartrate || oxygen)" class="green--text body-2 fs-16">מזהה מדדים</span>
            <span v-else class="orange--text body-2 fs-16">נא להרים את האצבע ולמקם מחדש</span>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-card color="transparent" class="transparent mt-2" elevation="0" max-width="600">
        <v-card-title>
          <v-icon color="red lighten-2" size="58">mdi-heart</v-icon>
          <v-layout column align-start>
            <div class="subheading grey--text text--darken-1 text-uppercase">דופק</div>
            <div v-if="heartrate">
              <strong>
                <v-icon>mdi-pulse</v-icon>
              </strong>
              <span class="display-1 font-weight-black red--text text--lighten-2">{{heartrate}}</span>
            </div>
            <div v-if="po === 1 && !heartrate" class="body-1 grey--text">
              מחפש מדדים
            </div>
            <div v-if="po === 3 && !heartrate" class="body-1 grey--text">
              לא מזהה
            </div>
          </v-layout>
        </v-card-title>
      </v-card>

      <v-card color="transparent" class="transparent mt-2" elevation="0" max-width="600">
        <v-card-title>
          <v-icon color="green lighten-2" size="58">mdi-lungs</v-icon>
          <v-layout column align-start>
            <div class="subheading grey--text text--darken-1 text-uppercase">חמצן</div>
            <div v-if="oxygen">
              <strong>
                <v-icon>mdi-percent-outline</v-icon>
              </strong>
              <span class="display-1 font-weight-black green--text text--lighten-2">{{oxygen}}</span>
            </div>
            <div v-if="po === 1 && !oxygen" class="body-1 grey--text">
              מחפש מדדים
            </div>
            <div v-if="po === 3 && !oxygen" class="body-1 grey--text">
              לא מזהה
            </div>
          </v-layout>
        </v-card-title>
      </v-card>

      <v-card color="transparent" class="transparent mt-2" elevation="0" max-width="600">
        <v-card-title>
          <v-icon color="blue lighten-2" size="58">mdi-thermometer</v-icon>
          <v-layout column align-start>
            <div class="subheading grey--text text--darken-1 text-uppercase">טמפרטורה</div>
            <div v-if="temperature">
              <strong>
                <v-icon>mdi-temperature-celsius</v-icon>
              </strong>
              <span class="display-1 font-weight-black blue--text text--lighten-2">{{temperature}}</span>
            </div>
            <div v-else class="body-1 grey--text">
              לא מחובר
            </div>
          </v-layout>
        </v-card-title>
      </v-card>

    </v-layout>

  </v-layout>
  <v-layout v-else-if="!subscribed" row wrap>
    <div class="headline text-xs-center my-5 mx-auto">
      <v-progress-circular
        :size="80"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
  </v-layout>
  <v-layout v-else row wrap class="py-5">
    <div class="headline text-xs-center my-5 mx-auto">
      צמיד {{selectedDevice + 1}} לא מחובר
    </div>
  </v-layout>

</template>
<script>

	export default {
		name: '',
    props: ['selectedDevice'],
		data: () => ({
      subscribed: false,
      devices: [
        {
          connected: false,
          heartrate: null,
          oxygen: null,
          temperature: null,
          ecgstatus: false,
          ecg: [],
          ecgKey: 0,
          po_status: false,
          po_received: null
        },
        {
          connected: false,
          heartrate: null,
          oxygen: null,
          temperature: null,
          ecgstatus: false,
          ecg: [],
          ecgKey: 0,
          po_status: false,
          po_received: null
        }
      ],
		}),
    computed: {
      po() {
        return this.devices[this.selectedDevice].po_status
        // if (this.selectedDevice === 0) return this.devices[0].po_status
        // if (this.selectedDevice === 1) return this.devices[1].po_status
      },
      heartrate() {
        return this.devices[this.selectedDevice].heartrate
        // if (this.selectedDevice === 0) return this.devices[0].heartrate
        // if (this.selectedDevice === 1) return this.devices[1].heartrate
      },
      oxygen() {
        return this.devices[this.selectedDevice].oxygen
        // if (this.selectedDevice === 0) return this.devices[0].oxygen
        // if (this.selectedDevice === 1) return this.devices[1].oxygen
      },
      temperature() {
        return this.devices[this.selectedDevice].temperature
        // if (this.selectedDevice === 0) return this.devices[0].temperature
        // if (this.selectedDevice === 1) return this.devices[1].temperature
      },
      ecg() {
        let ECG = this.devices[this.selectedDevice].ecg;
        return ECG;
        // if (this.selectedDevice === 0) ECG = this.devices[0].ecg
        // if (this.selectedDevice === 1) ECG = this.devices[1].ecg
        if (ECG.filter(x => x == 1024).length < 28) return ECG;
        return [
          1024, 1024, 1024, 1024, 1024, 1024, 1024, 1024,
          1024, 1024, 1024, 1024, 1024, 1024, 1024, 1024,
          1024, 1024, 1024, 1024, 1024, 1024, 1024, 1024,
          1024, 1024, 1024, 1024, 1024, 1024, 1024, 1024,
        ]
      },
      ecgKey() {
        if (this.selectedDevice === 0) return this.devices[0].ecgKey
        if (this.selectedDevice === 1) return this.devices[1].ecgKey
      }
    },
    mounted() {
      this.subscribe();
    },
    methods: {
      subscribe() {
        this.$socket.$subscribe('devices', payload => {
          this.subscribed = true;
          this.devices[0].connected = payload.one;
          this.devices[1].connected = payload.two;
          if (!payload.one && payload.two) {
            this.$emit('secondDevice');
          }
        });
        this.$socket.$subscribe('connected', payload => {
          if (payload == 1){
             this.devices[0].connected = true;
             if (this.selectedDevice === 1 && !this.devices[1].connected) {
               this.$emit('firstDevice');
             }
          }
          if (payload == 2){
             this.devices[1].connected = true;
             if (this.selectedDevice === 0 && !this.devices[0].connected) {
               this.$emit('secondDevice');
             }
          }
        });
        this.$socket.$subscribe('disconnected', payload => {
          if (payload == 1) {
            this.devices[0].connected = false;
            this.devices[0].heartrate = null
            this.devices[0].oxygen = null
            this.devices[0].temperature = null
            this.devices[0].ecg = []
          }
          if (payload == 2) {
            this.devices[1].connected = false;
            this.devices[1].heartrate = null
            this.devices[1].oxygen = null
            this.devices[1].temperature = null
            this.devices[1].ecg = []
          }
        });
        this.$socket.$subscribe('d1-temperature', payload => {
          this.devices[0].temperature = payload;
        });
        this.$socket.$subscribe('d1-po-status', payload => {
          this.devices[0].po_status = payload;
        });
        this.$socket.$subscribe('d1-po', payload => {
          // this.devices[0].heartrate = parseInt(payload.heartrate[payload.heartrate.length - 1])
          // this.devices[0].oxygen = parseInt(payload.oxygen[payload.oxygen.length - 1])
          // this.devices[0].po_received = + new Date()
          let h = parseInt(payload.heartrate[payload.heartrate.length - 1]);
          let o = parseInt(payload.oxygen[payload.oxygen.length - 1]);
          if (this.devices[0].po_received) {
            if((+ new Date() - this.devices[0].po_received) < 10000){
              h = h || this.devices[0].heartrate
              o = o || this.devices[0].oxygen
            }
          }
          this.devices[0].heartrate = h
          this.devices[0].oxygen = o
          this.devices[0].po_received = + new Date()
        });
        this.$socket.$subscribe('d1-ecg', payload => {
          this.devices[0].ecgKey++;
          this.devices[0].ecg = payload.map(num => parseInt(num));
        });
        this.$socket.$subscribe('d2-temperature', payload => {
          this.devices[1].temperature = payload;
        });
        this.$socket.$subscribe('d2-po-status', payload => {
          this.devices[1].po_status = payload;
        });
        this.$socket.$subscribe('d2-po', payload => {
          let h = parseInt(payload.heartrate[payload.heartrate.length - 1]);
          let o = parseInt(payload.oxygen[payload.oxygen.length - 1]);
          if (this.devices[1].po_received) {
            if((+ new Date() - this.devices[1].po_received) < 10000){
              h = h || this.devices[1].heartrate
              o = o || this.devices[1].oxygen
            }
          }
          this.devices[1].heartrate = h
          this.devices[1].oxygen = o
          this.devices[1].po_received = + new Date()
        });
        this.$socket.$subscribe('d2-ecg', payload => {
          this.devices[1].ecgKey++;
          this.devices[1].ecg = payload.map(num => parseInt(num));
        });
      }
    }
	};

</script>
